import React from "react";
import * as FaIcons from "react-icons/fa";
import { useCollection } from "../hooks/useCollection";

const FALLBACK_ICON = "FaDribbble";

const Services = () => {
  const { items, loading } = useCollection("services", "order", "asc");

  return (
    <section id="services" className="services section-bg">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Activities</h2>
          <p>กิจกรรมเสริมประสบการณ์ & การเรียนรู้</p>
        </div>

        {loading ? (
          <div className="text-center text-muted py-4">กำลังโหลด...</div>
        ) : items.length === 0 ? (
          <div className="text-center text-muted py-4">ยังไม่มีข้อมูลกิจกรรม</div>
        ) : (
          <div className="row">
            {items.map((service, index) => {
              const IconComp = FaIcons[service.icon] || FaIcons[FALLBACK_ICON];
              return (
                <div
                  key={service.id}
                  className="col-md-6 col-lg-3 d-flex align-items-stretch"
                  data-aos="zoom-in"
                  data-aos-delay={100 * (index + 1)}
                >
                  <div className="icon-box">
                    <div className="icon">
                      <IconComp size={40} className="service-icon" />
                    </div>
                    <h4 className="title">{service.title}</h4>
                    <p className="description">{service.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default Services;
